import React from 'react';

import './main.css';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation } from "swiper";
import QuotationMarks from '../../images/Customers Say/Vector.png'
import Deco from '../../images/Customers Say/Deco.png'

import "swiper/css";
import "swiper/css/pagination";

export default function CustomersSay() {
    return (
        <>
            <div className="customer-say">
                <div className="deco"></div>
                <div className="clients">
                    <h1>Что о нас говорят клиенты</h1>
                    <div className="Chelyabinsk">
                        <h1>1000</h1>
                        <p>Челябинцев доверились нам и остались довольны</p>
                    </div>
                </div>
                <div className="they-talk"></div>
                <div className="customer-carausel">
                    <Swiper
                        modules={[Navigation]}
                        slidesPerView={4}
                        spaceBetween={30}
                        navigation={true}
                        className="swiper-carausel"
                    >
                        <SwiperSlide className='swiper-slide'>
                            <div className="title-time">
                                <div className="quotation-marks">
                                    <img src={ QuotationMarks } alt="error" />
                                </div>
                                <div className="title">
                                    <h3>Андрей Першин</h3>
                                    <p>06.02.2022</p>
                                </div>
                            </div>
                            <div className="paragraph">
                                <p>Заказал отделку своего балкона дома, искал где заказать, наткнулся на техностиль в поисковике. Работы посмотрел - привлекли, цены тем более. Спасибо вам за качественную работу и хорошее отношение к ней</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='swiper-slide'>
                            <div className="title-time">
                                <div className="quotation-marks">
                                    <img src={ QuotationMarks } alt="error" />
                                </div>
                                <div className="title">
                                    <h3>Сергей Полюдов</h3>
                                    <p>05.02.2022</p>
                                </div>
                            </div>
                            <div className="paragraph">
                                <p>Остеклял балкон в квартире для насс семьей еще давно.  Работники очень хорошие, со стажем люди. Выполнена работа была без проблем и в срок. Цена хорошая. Оставляю только сейчас свой отзыв</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='swiper-slide'>
                            <div className="title-time">
                                <div className="quotation-marks">
                                    <img src={ QuotationMarks } alt="error" />
                                </div>
                                <div className="title">
                                    <h3>Константин Стрелков</h3>
                                    <p>24.01.2022</p>
                                </div>
                            </div>
                            <div className="paragraph">
                                <p>Теплое остекление - лучшее решение мне домой. Обратился в Техностиль, сотрудник по телефону все объяснила, цена устроила. Начали работу - выполнили очень хорошо все. Спасибо вам!</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='swiper-slide'>
                            <div className="title-time">
                                <div className="quotation-marks">
                                    <img src={ QuotationMarks } alt="error" />
                                </div>
                                <div className="title">
                                    <h3>Андрей Першин</h3>
                                    <p>06.02.2022</p>
                                </div>
                            </div>
                            <div className="paragraph">
                                <p>Заказал отделку своего балкона дома, искал где заказать, наткнулся на техностиль в поисковике. Работы посмотрел - привлекли, цены тем более. Спасибо вам за качественную работу и хорошее отношение к ней</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='swiper-slide'>
                            <div className="title-time">
                                <div className="quotation-marks">
                                    <img src={ QuotationMarks } alt="error" />
                                </div>
                                <div className="title">
                                    <h3>Андрей Першин</h3>
                                    <p>06.02.2022</p>
                                </div>
                            </div>
                            <div className="paragraph">
                                <p>Заказал отделку своего балкона дома, искал где заказать, наткнулся на техностиль в поисковике. Работы посмотрел - привлекли, цены тем более. Спасибо вам за качественную работу и хорошее отношение к ней</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='swiper-slide'>
                            <div className="title-time">
                                <div className="quotation-marks">
                                    <img src={ QuotationMarks } alt="error" />
                                </div>
                                <div className="title">
                                    <h3>Андрей Першин</h3>
                                    <p>06.02.2022</p>
                                </div>
                            </div>
                            <div className="paragraph">
                                <p>Заказал отделку своего балкона дома, искал где заказать, наткнулся на техностиль в поисковике. Работы посмотрел - привлекли, цены тем более. Спасибо вам за качественную работу и хорошее отношение к ней</p>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </>
    )
}
